import { Component } from '@angular/core';
import { FileManagerComponent } from '../../../components/pages/file-manager/file-manager.component';

@Component({
  selector: 'app-finance-file-manager',
  imports: [FileManagerComponent],
  templateUrl: './finance-file-manager.component.html',
  styleUrl: './finance-file-manager.component.scss'
})
export class FinanceFileManagerComponent {
  initialPath: string = 'finance';
}
